<template>
  <v-container
    fluid
    grid-list-md
    text-xs-center
    style="min-height: 100vh;"
  >
    <v-layout
      row
      wrap
    >
      <v-toolbar
        scroll-target="#scrolling-home"
        class="workshop-toolbar"
      >
        <v-layout
          style="height: 100%"
        >
          <v-flex
            xs2
            class="centerContent"
          >
            <v-toolbar-title>
              <div
                class="centerContent"
              >
                <div
                  class="d-inline-block"
                >
                  Salones
                </div>
              </div>
            </v-toolbar-title>
          </v-flex>
          <v-flex
            xs10
            style="padding: 10px"
            v-if="false"
          >
            <v-layout 
              wrap
              row
              class="centerContent"
            >
              <v-flex
                xs10
                class="padding-flex"
              >
                <v-layout>
                  <v-flex 
                    class="titleSearch"
                  >
                    <v-text-field
                      flat
                      label="Buscar"
                      append-outer-icon="search"
                      @click:append-outer="filterSearch"
                      @click:clear="filterSearchClear"
                      @keyup.enter="filterSearch"
                      solo-inverted
                      v-model="filters.search"
                      clearable
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>        
        <v-tooltip
          right
        >
          <v-btn
            color="gradiente"
            dark
            small
            absolute
            bottom
            left
            fab
            slot="activator"
            @click="roomEditObject = {}; showCreateClassRoom = true; "
          >
            <v-icon>add</v-icon>
          </v-btn>
          <span>Crear salón</span>
        </v-tooltip>
      </v-toolbar>
      <v-container
        fluid
        elevation-2
        style="min-height: 100vh;"
        class="scrollDesign table-full"
        grid-list-md
      >
        <v-layout
          row
          wrap
        >
          <v-flex>
            <v-data-table
              :headers="headers"
              :rows-per-page-items="[ 25, 50, 100]"
              rows-per-page-text="Registros por página"
              :items="rooms"
              :pagination.sync="pagination"
              :total-items="totalItemsFromBackend"
              item-key="id"
              no-results-text="No se encontraron coincidencias"
            >
              <template v-slot:headers>
                <tr>
                  <th class="table-row-size">
                    Nombre del salón
                  </th>
                  <th class="table-row-options-size" />
                </tr>
              </template>
              <template v-slot:items="props">
                <tr>
                  <td class="table-row-size">
                    {{ props.item.classroomName }} 
                  </td>
                  <td class="centerContent">
                    <div
                      class="icon items-in-block over"
                      @click="editRoom(props.item)"
                    >
                      <v-icon>
                        edit
                      </v-icon>
                    </div>
                    <div
                      class="icon items-in-block over ml-3"
                      @click="deleteRoom(props.item)"
                    >
                      <v-icon>
                        delete
                      </v-icon>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-slot:pageText="props">
                {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <create-room
      v-model="showCreateClassRoom"
      :roomEdit="roomEditObject"
      @close="closeCreateRoom"
    />
    <simple-confirm
      v-model="confirmDialog"
      :message="messageConfirm"
      @save="confirmSave"
    />
    <success
      v-model="toast.success"
      text="Operación Exitosa"
    />
    <error
      v-model="toast.failed"
      :text="messageError"
    >
    <!--<enrolled-student
      v-model="modals.enrolledStudent"
      :workshopEdit="roomEditObject"
      :isEnrolled="isEnrolled"
      @close="closeDetails"
    />
    /> -->
    </error>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import { getMessageError } from '../../../plugins/GeneralMethods';
import Error from '../../Dialogs/Error.vue';
import Success from '../../Dialogs/Success.vue';
import CreateRoom from '../../Modals/room/CreateRoom.vue';
import SimpleConfirm from '../../Modals/workshops/SimpleConfirm.vue';

export default {
    components: {
        CreateRoom,
        Error,
        Success,
        SimpleConfirm
    },
    data: () => ({
      headers: [
        {
          text: "Nombre del salón",
          filterItems: [],
        }
      ],
      selected: [],
      roomEditObject: {}, 
      rooms: [],
      showCreateClassRoom: false,
      toast: {
        success: false,
        failed: false
      },
      messageConfirm: "",
      confirmDialog: false,
      totalItemsFromBackend: 0,
      pagination: {},
      filters: {
        search: ""
      },
      working: true,
      isFirsPagination: true,
      messageError: ""
    }),
    mounted() {
      if (this.getBranch.id != null) {
          this.getClassrooms()
        }
    },
    watch: {
      getBranch() {
        if (this.getBranch.id != null) {
          this.getClassrooms()
        }
      },
      pagination: {
        handler() {
          if (!this.isFirsPagination){
           this.getClassrooms();
          }else{
            this.isFirsPagination = false
          }
        }
      }
    },
    computed: {
      ...mapGetters(["getBranch"]),
    },
    methods: {
      filterSearchClear() {
        this.filters.search = ""
        this.getClassrooms();
      },
      filterSearch() {
        this.getClassrooms();
      },
      toggleAll() {
        if (this.selected.length) this.selected = [];
        else this.selected = this.$refs.table.filteredItems.slice();
      },
      editRoom(classroom){
        this.roomEditObject = classroom
        this.showCreateClassRoom = true
      },
      deleteRoom(classroom) {
        this.roomEditObject = classroom
        this.messageConfirm = "¿Estas seguro de que quieres eliminar el salón de clases: "+ classroom.classroomName + "?"
        this.confirmDialog = true
      },
      getClassrooms() {
        let pageSize = this.pagination.rowsPerPage == -1 ? this.totalNotices : this.pagination.rowsPerPage;
        let currentPage = this.pagination.page - 1;
        let offset = currentPage * pageSize;
        const body = {
            "search": this.filters.search,
            "offset": offset,
            "size": pageSize
        }
        this.$store
          .dispatch("classRoom/getClassrooms", body)
          .then(response => {
            this.rooms = response.data.entity
            this.working = false
            this.totalItemsFromBackend = response.data.size
          })
          .catch((response) => {
              this.messageError = getMessageError(response.data)
              this.toast.failed = true
              this.working = false
              this.rooms = []
          });
      },
      closeCreateRoom(){
        this.getClassrooms()
      },
      confirmSave(){
        const body = [{classroomId: this.roomEditObject.classroomId}]
        this.$store
          .dispatch("classRoom/deleteClassroom", body)
          .then(() => {
            this.toast.success = true
            this.getClassrooms()
          })
          .catch((response) => {
            this.messageError = getMessageError(response.data)
            this.toast.failed = true
          });
      }
    }
}
</script>

<style scoped>

.table-row-size {
  width: 300px !important; 
  max-width: 300px !important; 
  min-width: 300px !important;
}

.table-row-options-size {
  width: 150px !important; 
  max-width: 150px !important; 
  min-width: 150px !important;
}

.table-checkbox-size {
  width: 10% !important; 
  max-width: 10% !important; 
  min-width: 10% !important;

}

.items-in-block {
  display: inline-block;
}

/deep/ .main-tool-bar .v-toolbar__content{
  height: auto !important;
}

/deep/ .table-full .v-datatable.v-table > tbody{
  max-height: calc(106vh - 426px);
  min-height: calc(106vh - 426px);
}

</style>